import { memo, useMemo } from 'react'
import { IonButton } from '@ionic/react'
import uniqueId from 'lodash/uniqueId'

import { Flash } from '@/components/atoms/assets/Flash'

import { useRemainingVotes } from '@services/votes'

const RemainingVoteCountComponent = ({
  className = '',
}: {
  className?: string
}) => {
  const { votes } = useRemainingVotes()
  const uuid = useMemo(() => uniqueId(), [])

  return (
    <>
      <IonButton className="plain vote-count" id={uuid}>
        <span className="text-xl font-bold">{votes}</span>
        <span className={`text-lg flex items-center ${className}`}>
          <Flash />
        </span>
      </IonButton>
    </>
  )
}

export const RemainingVoteCount = memo(RemainingVoteCountComponent)
